import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { addIcons } from 'ionicons';
import * as icons from 'ionicons/icons';
import { initializeApp } from 'firebase/app';
import { environment } from './environments/environment';
import { apiSignatureInterceptor } from './app/common/services/api-signature.interceptor';

// Initialize Firebase
initializeApp(environment.firebase);
 
addIcons(icons);
bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptors([apiSignatureInterceptor])),
    provideIonicAngular({
      mode: 'md' // Force Material Design (Android) theme globally
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
  ],
});
